var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fileStyleName",attrs:{"title":_vm.dwgFileName}},[_c('img',{attrs:{"src":require("./../images/title.png"),"alt":"图标"}}),_c('span',[_vm._v(_vm._s(_vm.dwgFileName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }